import store from '@/store/index'

export const redirectIfNotAccessEvents = () => (to, from, next) => {
  if (!store.getters['auth/canAccessEvents']) {
    store.commit('notify/set', {message: '予定にアクセスする権限がありません'})
    // URLを直叩きされた場合はホーム画面へリダイレクト
    if (from.path === '/') {
      next('/')
      return
    }
    next(false)
    return
  }
  next()
}